import { TSectionsKeys } from '../../model/IStoreTypes';
import scrollInView, { ScrollInViewBehaviourType, ScrollInViewType } from '../../../common/service/scrollInView';
import { customiseActions } from '../../store/reducers/customiseReducer';
import { useDispatch } from 'react-redux';
import { MouseEvent, useCallback } from 'react';
import { CustomiseSections } from '../../../common/enum/CustomiseSections';
import customise from '../../constants/customise';
import useStockUrl from './useStockUrl';
import { useHistory } from 'react-router-dom';
import { routeUtils } from '../../../common/utils/routeUtils';

interface IUseScrollToSection {
  scrollToSection: (name: string, scrollBehaviour?: ScrollInViewBehaviourType) => void;
  scrollToDisclaimer: (e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => void;
}

export default function useScrollToSection(): IUseScrollToSection {
  const dispatch = useDispatch();
  const { listUrl } = useStockUrl();
  const history = useHistory();

  const scrollToSection = useCallback((name: string, scrollBehaviour?: ScrollInViewBehaviourType) => {
    const selectedSectionName = name.toLowerCase() as TSectionsKeys;
    const selectedSectionElement = document.getElementById(`${customise.DOM_ID_PREFIX}${selectedSectionName}`);
    const disclaimerElement = document.querySelector(`[id*="${'disclaimer'}"]`) as HTMLElement;

    if (name === customise.STOCK_ITEM.name) {
      return routeUtils.pushWithQueryParams(history, listUrl);
    }

    if (selectedSectionElement) {
      scrollInView.scrollInView(
        selectedSectionElement,
        ScrollInViewType.TOP,
        scrollBehaviour ?? ScrollInViewBehaviourType.AUTO,
      );
      dispatch(customiseActions.setAccordionStatus({ name: selectedSectionName, expanded: true }));
    }

    if (disclaimerElement && !selectedSectionElement) {
      scrollInView.scrollInView(
        disclaimerElement,
        ScrollInViewType.TOP,
        scrollBehaviour ?? ScrollInViewBehaviourType.AUTO,
      );
      return;
    }
    dispatch(customiseActions.setSelectedSection(selectedSectionName));
  }, []);

  const scrollToDisclaimer = useCallback((e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    scrollToSection(CustomiseSections.DISCLAIMER, ScrollInViewBehaviourType.SMOOTH);
  }, []);

  return { scrollToSection, scrollToDisclaimer };
}
